import { httpClient } from 'utils/http/httpClient';

import { productDumpConnector } from './productDump';

export const productDumpApi = productDumpConnector(httpClient);

export type ProductDumpApi = typeof productDumpApi;
